<template>
    <div class="single-detail">
        <div class="book-meeting">
            <span @click="goMeetingList" class="meeting-arrow"></span>
            会议详情
        </div>
        <div class="meeting-type meeting-time">
            <div class="type-tittle">
                <span>会议描述</span>
            </div>
            <div class="content">
                <p class="theme">
                    <span class="theme-tittle">案号：</span>
                    <span class="theme-cont">{{meetinTittle}}</span>
                </p>
                <p class="case-number">
                    <span class="theme-tittle">案由：</span>
                    <span class="theme-cont">{{causeName}}</span>
                </p>
            </div>
        </div>
        <div class="meeting-type single-time">
            <div class="type-tittle">
                <span>会议时间</span>
            </div>
            <p class="time">
                <span class="date">会议日期：</span>
                <span class="date-detail">{{meetingDate}}</span>
            </p>
        </div>
        <div class="relation-meterail">
            <div class="type-tittle">
                <span class="meterail">相关材料</span>
                <span v-if="downFlag" class="all-load" @click="clickAllDownLoad">一键下载</span>
            </div>
            <div v-if="!this.downFlag"  class="no-data">暂无相关材料</div>
            <el-form v-if="this.downFlag" :disabled="true" class="file-form"  :model="allFile"  ref="allFile" label-width="90px">
                <el-row
                    v-for="(ff, ffindex) in allFile.fileform"
                    :key="ffindex"
                    type="flex"
                    justify="space-between"
                    >
                    <el-col :span="6">
                        <el-form-item label="角色：">
                            <el-select v-model="ff.categorySmall" class="widthauto" placeholder="请选择" >
                                <el-option
                                    v-for="item in roleOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="材料分类：">
                            <el-select v-model="ff.categoryMiddle" @change="changefiletype($event, ffindex)" class="widthauto" placeholder="请选择" >
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="材料名称：" >
                            <el-input v-model="ff.remark" placeholder="请输入材料名称" class="widthauto"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                            <el-form-item label="材料附件：">
                            <el-input v-model="ff.fileName" placeholder="请输入材料名称" class="widthauto"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1">
                        <span class="icon-name" @click="downSingleFile(ff)" >
                            <i class="el-icon-download" ></i><span class="delete-name">&nbsp;&nbsp;下载</span>
                        </span>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="relation-meterail">
            <div class="type-tittle">
                <span class="meterail">笔录材料</span>
                <span v-if="attendFlag" class="all-load" @click="openDocumentSign">笔录签署</span>
                <!-- <span v-if="createdFlag" class="all-load" @click="dialogRecord">制作笔录</span> -->
            </div>
            <div v-if="!recordFlag" class="no-data">暂无笔录材料</div>
            <el-form v-if="recordFlag" disabled class="file-form"  :model="allFile"  ref="allFile" label-width="90px">
                <el-row
                    v-for="(ff, ffindex) in recordAttaList"
                    :key="ffindex"
                    type="flex"
                    justify="space-between"
                    >
                    <el-col :span="7">
                        <el-form-item label="材料分类：">
                            <el-select v-model="ff.categoryMiddle" @change="changefiletype($event, ffindex)" class="widthauto" placeholder="请选择" >
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="材料名称：" >
                            <el-input v-model="ff.fileName" placeholder="请输入材料名称" class="widthauto"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                            <el-form-item label="材料附件：">
                            <el-input v-model="ff.fileName" placeholder="请输入材料名称" class="widthauto"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col  :span="1"  >
                        <span  class="icon-name" @click="downRecordFile(ff)" >
                            <i class="el-icon-download" ></i><span class="delete-name">&nbsp;&nbsp;下载</span>
                        </span>
                    </el-col> -->
                </el-row>
            </el-form>
        </div>
        <div class="attendant-number">
            <div class="type-tittle">
                <span>参会人员</span>
            </div>
            <div class="number" v-for="(item,index) in memberList" :key="index">
                <p>
                    <span class="member-name">身份类型：</span>
                    <span class="member-single">{{userTypeObj[item.meetingUserType]}}</span>
                </p>
                <p>
                    <span class="member-name">姓名：</span>
                    <span class="member-single">{{item.userName}}</span>
                </p>
                <p>
                    <span class="member-name">身份证号：</span>
                    <span class="member-single">{{item.idCard}}</span>
                </p>
                <p>
                    <span class="member-name">手机：</span>
                    <span class="member-single">{{item.mobilePhone}}</span>
                </p>
            </div>
        </div>
<!--        <div class="attendant-number">-->
<!--            <div class="type-tittle">-->
<!--                <span>邀请无画面观摩人 <span>最多支持n个观摩人员</span> </span>-->
<!--                <div class="addpeo-button">-->
<!--                    <div class="sumbit" @click="saveInviteVisitors">保存</div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <el-form :model="invitenopic" class="attendant-form-detail" :rules="rules" ref="invitenopic" label-width="100px">-->
<!--                <el-row>-->
<!--                    <el-form-item prop="userName" label="姓名：">-->
<!--                        <el-input v-model="invitenopic.userName" placeholder="请输入姓名"  class="widthauto"></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item prop="mobilePhone" label="手机：">-->
<!--                        <el-input v-model="invitenopic.mobilePhone" maxlength="11" placeholder="请输入手机号" class="widthauto"></el-input>-->
<!--                    </el-form-item>-->
<!--                </el-row>-->
<!--            </el-form>-->
<!--        </div>-->
        <el-dialog class="detail-record" :title="dialogTittle" :close-on-click-modal=false :visible.sync="dialogVisible" :modal-append-to-body="false" :before-close="recordClose" width="760px">
            <div class="vb">
                <i v-if="createdFlag" class="dialog_edit_icon" @click="formStatus"></i>
                <div class="md-wrap">
                    <el-form :model="mediationForm" label-position="left" :rules="mediationrules" ref="mediationForm" class="demo-ruleForm" :disabled="formtype">
                        <!-- <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="时间:" label-width="55px" prop="time">
                                    <el-input v-model="mediationForm.time" placeholder="请输入时间" size="small"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工作人员:" label-width="70px">
                                    <el-input v-model="mediationForm.clerkPersonal[0].userName" placeholder="请输入主持人" size="small"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="地点:" label-width="55px"  prop="location">
                            <el-input v-model="mediationForm.location" placeholder="请输入地址" size="small"></el-input>
                        </el-form-item> -->

                        <el-form-item label="笔录：" label-width="'auto'" prop="content">
                            <el-input type="textarea" :rows="12" v-model="mediationForm.content" placeholder="请填写详细内容"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <div v-if="!signFlag"  slot="footer" class="dialog-footer">
                <el-button v-if="formtype&&Boolean(sendButtonStatus=='SEND_YES')" type="primary" :disabled="buttonStatus">已发送</el-button>
                <el-button v-else @click="sendRecord" class="btnlr-gradient" :disabled="buttonStatus">{{sendButtonStatus=='SEND_YES'?'已发送':'发送'}}</el-button>
                <el-button v-if="formtype&&!Boolean(sendButtonStatus=='SEND_YES')" type="primary" :disabled="buttonStatus">已保存</el-button>
                <el-button v-else-if="formtype&&Boolean(sendButtonStatus=='SEND_YES')" icon="el-icon-refresh" @click="refresh()" :disabled="buttonStatus">刷新</el-button>
                <el-button v-else type="primary" :loading="saveBtnLoading" @click="saveRecord" :disabled="buttonStatus">{{Boolean(saveButtonStatus)?'已保存':'保存'}}</el-button>
            </div>
            <div v-if="signFlag"  slot="footer" class="dialog-footer">
                <el-button  v-if="!isSignFlag"  @click="openSign" type="primary">签署</el-button>
                <el-button v-if="isSignFlag"  @click="openSign" disabled type="primary">已签署</el-button>
            </div>

            <el-dialog
                width="345px"
                title="扫描二维码"
                :visible.sync="innerVisible"
                :close-on-click-modal=false
                :before-close="handleClose"
                append-to-body>
                <img :src="weixincode">
                <div class="dialog-footer">
                    <el-button type="primary" @click="sendout" :disabled="buttonStatus">已经完成手写签名</el-button>
                </div>
            </el-dialog>
        </el-dialog>
        <el-dialog class="document-sign" title="文书签名" :close-on-click-modal=false :visible.sync="documentVisible" :modal-append-to-body="false"  width="494px">
            <div class="sign-top">
                <img :src="wxSignCode" alt="">
                <div class="sign-discrible">
                    <el-radio v-model="selectSign" label="hanleSign">手写签名</el-radio>
                    <div class="explain">说明：</div>
                    <div class="sort">
                        <span class="num">1</span>
                        <span>用微信</span>
                        <span class="scan">扫描左方二维码</span>
                    </div>
                    <div class="sort">
                        <span class="num">2</span>
                        <span>前往微信小程序完成手写签名</span>
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="sign-top sign-line">
                <img v-if="holdSignFlag" :src="holdSignCode" alt="">
                <div v-if="!holdSignFlag" class="hold-sign">待签名</div>
                <div class="sign-discrible">
                    <el-radio v-model="selectSign" label="resetSgin">使用预留签名</el-radio>
                    <span v-if="!holdSignFlag" @click="noSet" class="no-set" >未设置</span>
                    <div class="explain">说明：</div>
                    <div class="sort reset">
                        <span>文书直接使用已有的“文书签名”</span>
                    </div>
                    <div class="sort reset">
                        <span>可在个人中心-账号设置下修改</span>
                    </div>
                </div>
            </div>
            <div @click="endSign" class="end">完成</div>
        </el-dialog>
    </div>
</template>
<script>
import {getMeetingDetail,clickAllDownLoad,getClerkRecord,saveClerkRecord,sendClerkRecord,signatureConfirmInfo,clerkConfirmQrCode,clerkConfirm,clerkRecordAttaList, inviteVisitorsnopic} from '@/api/meeting'
import {searchLoginUserInfo} from '@/api/userCenter'
import {ERR_OK} from '@/api/reConfig'
import config from '@/config/config'
import axios from 'axios'

import {dateformat,setStore, getStore, removeStore, getStoreSession, getUrlParams } from '@/utils/utils.js'
export default {
    data() {
       return {
            meetinTittle:"",
           causeName: "",
            caseNum:"",
            caseDescribe:"",
            meetingDate:"",
            selectValue:"",
            materialClassify:"",
            memberList:[],
            datePickerStatus:true,
            acceptType: '.doc,.docx,.pdf,.png,.jpg,.jpeg',
            flk: {JWTToken: '', appName: 'gzzc',cType:'PC'},
            uploaddata: {
                    isView: 'NOVIEW'
                },
            typeform:{
                type:"jointMeeting",
                tittle:""
            },
            timeform:{
                type:"immediately",
                date:"",
                orderDate:'',
                orderNewTime:'',
            },
            allFile:{
                fileform: [
                    {
                        filetype: '',  //材料分类的名称
                        filename: '', // 材料名称
                        filelist: [],  // 材料附件
                        categoryMiddle: '',
                        categorySmall: '',
                        disableFlag:false,
                        showDelete: true   // 是否显示删除按钮
                    }
                ]
            },
            allMember:{
                attendantform:[
                    {
                        attendantName:"",
                        attendantPhone:""
                    }
                ]
            },
            options: [{
                    value: 'IDENTITY_CERTIFICATE',
                    label: '身份证明'
                },{
                    value: 'EVIDENCE_INVENTORY',
                    label: '证据清单'
                },{
                    value: 'OTHER',
                    label: '其他'
                },{
                    value: 'DOCUMENT_MATERIAL',
                    label: '文书材料'
                }
            ],
            userTypeObj: {
                'APPLICANT': '申请人',
                'RESPONDENT': '被申请人',
                'OTHER': '其他人',
                'APPLICANT_AGENT': '申请人代理人',
                'RESPONDENT_AGENT': '被申请人代理人',
                'MEDIATOR': '仲裁员',
            },
            roleOptions: [{
                value: 'APPLICANT',
                label: '申请人',
            },{
                value: 'RESPONDENT',
                label: '被申请人',
            },{
                value: 'MEDIATOR',
                label: '仲裁员',
            },{
                value: 'OTHER',
                label: '其他人',
            }],
            typeroleList: [{
                name: '申请人',
                code: 'APPLICANT'
            },
            {
                name: '被申请人',
                code: 'RESPONDENT'
            },{
                name: '其他人',
                code: 'OTHER'
            }],
            typeList:[{
                name:"联席会议",
                code:"MEETING_JOINT"
                },{
                name:"在线磋商",
                code:"MEETING_ONLINE"
                }
            ],
            bookList:[{
                name:"预约会议",
                code:"ORDER_TYPE"
                },{
                name:"立即开始",
                code:"IMMEDIATELY_TYPE"
                }
            ],
            disabledDateOptions: {
                disabledDate(time) {
                    return time.getTime() < (new Date().getTime()-3600*24*1000);
                }
            },
            mediationForm: {
                // time: '',
                // location: '',
                content: '',
                // clerkPersonal:[{
                //     userName:""
                // }]
            },
            mediationrules: {
                // name: [
                //     { required: true, message: '请输入姓名', trigger: 'blur' }
                // ],
                // location: [
                //     { required: true, message: '请输入地址', trigger: 'blur' }
                // ],
                // time: [
                //     { required: true, message: '请输入时间', trigger: 'blur' }
                // ],
                content: [
                    { required: true, message: '请输入笔录', trigger: 'blur' }
                ]
            },
            disabledTimeOptions:{},
            multipleSelection: [],
            downFlag:true,
            caseNumFlag:false,
            formtype :true,
            dialogVisible:false,
            innerVisible:false,
            buttonStatus:false,
            documentVisible:false,
            selectSign:'hanleSign',
            sendButtonStatus: null,
            saveButtonStatus: null, // 如果有生成文书ID 表示已保存
            weixincode: '',
            BtnLoading:false,
            saveBtnLoading:false,
            userData:{},
            documentId:'',
            loginUserId:0,
            attendFlag :false,
            createdFlag :false,
            signFlag:false,
            wxSignCode:"",
            holdSignFlag:false,
            actionUrl :`${config.baseURL}/gzzc/clerkOpinion/clerkConfirm`,
            recordAttaList:[],
            recordFlag:false,
            fileSignList:[],
            isSignFlag:false,
            dialogTittle:"",
            signResetFlag:false,
            invitenopic: {
                userName: '',
                mobilePhone: ''
            },
            rules: {
                userName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                mobilePhone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                ],
            },
       }
    },
    created(){
        if(getStore('loginInfo')){
            this.loginUserId = JSON.parse(getStore('loginInfo')).userInfo.userId
        }else if(JSON.parse(getStore('loginInfouser'))){
            this.loginUserId = JSON.parse(getStore('loginInfouser')).userInfo.userId
        }
        if(getStore('loginInfo')) {
            this.flk.appName = getStore('appName')
        }
        this.flk.JWTToken = getStore('flk');
        this.clerkRecordList()

    },
    mounted() {
        if(getStore('isOutter') == 1) {
            document.querySelector('.el-header').style.display = 'none'
            document.querySelector('.el-aside').style.display = 'none'
        }
        this.getMeetingDetail()
        this.caseNumFlag = this.$route.query.caseId ? true :false
        this.getType('erer2323.png')


    },
    filters: {
        userFilter: function(val) {
            let ret = '123'
        }
    },
    methods: {
        //笔录材料
        clerkRecordList(){
            clerkRecordAttaList({
                objectId:this.$route.query.meetingId,
                objectType:'MEDIATION'
            }).then(res =>{
               this.recordAttaList = res.data.data
               if(this.recordAttaList&&this.recordAttaList.length>0){
                   this.recordFlag = true
               }
            },erro =>{

            })
        },
        //制作笔录
        dialogRecord() {
            this.getMediationRecord()
            this.searchLoginUserInfo()
            this.dialogVisible = true


        },
        formStatus() {
            this.formtype = false
            this.sendButtonStatus = null
            this.saveButtonStatus = null
        },
        sendout() {
            if(this.signResetFlag){
                searchLoginUserInfo({}).then(res => {
                    if(res.data.code === 1000) {
                        this.userData = res.data.data
                        if(res.data.data.signatureFileUrl){
                            this.holdSignFlag = true
                            this.holdSignCode = res.data.data.signatureFileUrl
                        }
                    }
                }).catch(err => {
                    this.$message({
                        type: 'error',
                        message: err
                    })
                })
            } else {
                this.buttonStatus =  true
                signatureConfirmInfo({
                    documentIds: [this.documentId]
                }).then((res) => {
                    if(res.data.code === 1000) {
                        if(res.data.data){
                            this.$message({message: '签名成功',type: 'success'});
                            setTimeout(()=>{
                                this.clerkRecordList()
                                this.innerVisible = false;
                                this.dialogVisible = false;
                                this.formtype = true;
                            })
                        }else {
                            this.$message({message: '未完成签名',type: 'warning'});
                        }
                    }else {
                        this.$message.error(res.data.message)
                    }
                    this.buttonStatus =  false
                },(error) => {
                    this.buttonStatus =  false
                })
            }
        },
        endSign() {
            if(this.selectSign == 'hanleSign'){
                signatureConfirmInfo({
                    documentIds: [this.documentId]
                }).then((res) => {
                    if(res.data.code === 1000) {
                        if(res.data.data){
                            this.$message({message: '签名成功',type: 'success'});
                            setTimeout(()=>{
                                this.dialogVisible = false
                                this.documentVisible =false
                                this.formtype = true
                            })
                        }else {
                            this.$message({message: '请扫描二维码完成签名',type: 'warning'});
                        }
                    }else {

                        this.$message.error(res.data.message)
                    }
                    this.buttonStatus =  false
                },(error) => {
                    this.buttonStatus =  false
                })

            } else {
                clerkConfirm(this.documentId).then(res => {
                    if(res.data.code === 1000) {
                        if(!res.data.data.message){
                            this.$message({message: '签名成功',type: 'success'});
                        } else {
                            this.$message({message: '您已同意并确认笔录',type: 'warning'});
                        }
                        setTimeout(() =>{
                            this.dialogVisible = false
                            this.documentVisible =false
                            this.formtype = true
                        })
                    } else if(res.data.code === 1003){
                        this.noSet()
                        this.signResetFlag = true
                    }
                },erro =>{
                    this.$message.error(res.data.message)
                })
            }
            this.clerkRecordList()
        },
        handleClose(done) {
            if(!this.signFlag){
                this.buttonStatus =  true
                this.sendout()
            } else {
                searchLoginUserInfo({}).then(res => {
                    if(res.data.code === 1000) {
                        this.userData = res.data.data
                        if(res.data.data.signatureFileUrl){
                            this.holdSignFlag = true
                            this.holdSignCode = res.data.data.signatureFileUrl
                        }
                    }
                }).catch(err => {
                    this.$message({
                        type: 'error',
                        message: err
                    })
                })
            }
            this.innerVisible = false
        },
        recordClose(done) {
            this.formtype = true
            this.$refs["mediationForm"] && this.$refs["mediationForm"].clearValidate()
            done()
        },
        refresh() {
            this.getMediationRecord()
        },
        getMediationRecord() {
            //this.curmeetingRecordId = id
            getClerkRecord(
                {
                    bizId: this.$route.query.meetingId,
                    docId: this.documentId,
                    meetId: this.$route.query.meetingId
                }
            ).then((res) => {
                if(res.data.code == 1000){
                    this.mediationForm = res.data.data;
                    this.documentId = res.data.data.docId
                    let tempContent = res.data.data.content
                    tempContent = tempContent.replace(/^\n+/g,"");
                    if( tempContent.indexOf('\n\n') >0){
                        tempContent = tempContent.replace(/[\n]{2}/g,"\n")
                    }
                    this.mediationForm.content = tempContent
                    this.sendButtonStatus = res.data.data.sendStatus;
                    this.saveButtonStatus = res.data.data.docId;
                    this.actionUrl = `${config.baseURL}/gzzc/clerkOpinion/clerkConfirm?userId=${this.loginUserId}&documentIds=${this.documentId}&degree=0`
                    if(!Boolean(res.data.data.docId)) this.formStatus();
                    if(this.attendFlag){
                        signatureConfirmInfo({
                            documentIds: [this.documentId]
                        }).then((res) => {
                            if(res.data.code === 1000) {
                                if(res.data.data == '签名成功'){
                                    this.isSignFlag = true
                                }else if(res.data.data && res.data.data != '签名成功') {
                                    this.$message({message: res.data.data,type: 'warning'});
                                }
                            }else {

                            }
                        },(error) => {
                        this.$message.error(error.data.message)
                        })
                    }
                }else{
                    this.$message.error(res.data.message)
                }
            },(error) => {

            })
        },
        sendRecord() {
            let params = {
                    bizId: this.mediationForm.bizId,
                    bizNo: this.mediationForm.bizNo,
                    content: this.mediationForm.content,
                    disputeType: "MEDIATION",
                    docId:this.documentId,
                    location:this.mediationForm.location,
                    mediatorName: this.mediationForm.clerkPersonal[0].userName,
                    meetId: this.$route.query.meetingId,
                    orgId: this.userData.orgId,
                    orgName: this.userData.orgName,
                    remark: this.mediationForm.remark,
                    time: this.mediationForm.time
                }
                this.$refs['mediationForm'].validate((valid) => {
                if (valid) {
                    this.BtnLoading=true;
                    this.buttonStatus =  true;
                    if(this.mediationForm.remark==null){
                        this.mediationForm.remark=0
                    }
                    sendClerkRecord(params).then((res) => {
                        if(res.data.code == 1000) {
                            this.documentId = res.data.data.documentId
                            this.weixincode = res.data.data.launchSign+"/gzzc"
                            this.innerVisible = true
                        }else{
                            this.$message.error(res.data.message)
                        }
                        this.BtnLoading=false;
                        this.buttonStatus =  false
                    })
                }
            });
        },
        saveRecord() {
            if(this.formtype) return;

            if(this.mediationForm.remark==null){
                this.mediationForm.remark=0
            }
            let params = {
                    bizId: this.mediationForm.bizId,
                    bizNo: this.mediationForm.bizNo,
                    content: this.mediationForm.content,
                    disputeType: "MEDIATION",
                    docId:this.documentId,
                    location:this.mediationForm.location,
                    mediatorName: this.mediationForm.clerkPersonal[0].userName,
                    meetId: this.$route.query.meetingId,
                    orgId: this.userData.orgId,
                    orgName: this.userData.orgName,
                    remark: this.mediationForm.remark,
                    time: this.mediationForm.time
                }

            this.$refs['mediationForm'].validate((valid) => {
                if (valid) {
                    this.buttonStatus =  true
                    this.saveBtnLoading=true;
                saveClerkRecord(params).then((res) => {
                        if(res.data.code == 1000) {
                            this.documentId = res.data.data.documentId;
                            this.formtype = true;
                            this.$message({message: '保存成功',type: 'success'});
                            this.buttonStatus =  false;
                            this.saveBtnLoading=false;
                        }else{
                            this.$message.error(res.data.message)
                        }

                    })
                }
            });
        },
        searchLoginUserInfo() {
            searchLoginUserInfo({}).then(res => {
                if(res.data.code === 1000) {
                    this.userData = res.data.data
                    if(res.data.data.signatureFileUrl){
                        this.holdSignFlag = true
                        this.holdSignCode = res.data.data.signatureFileUrl
                    }
                }
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: err
                })
            })
        },
        //用户文书签名

        openDocumentSign() {
            this.signFlag = true
            this.dialogRecord()
        },
        //未设置
        noSet(){
            this.innerVisible = true
            let instance
            if(getStore('appName')) {
                instance = axios.create({headers:{'JWTToken':getStore('flk'),'cType':'PC','appName':getStore('appName')}});
            }else{
                instance = axios.create({headers:{'JWTToken':getStore('flk'),'cType':'PC','appName':'gzzc'}});
            }
            instance({
                method:'post',
                url:'/gzzc/signature/showSignNameQrCode',
                data: {},
                responseType:'arraybuffer'
            }).then(res => {
                this.weixincode = window.URL.createObjectURL(new Blob([res.data],{type:'image/png;charset=UTF-8' }));
            })
        },
        //弹出签名弹窗
        openSign() {
            this.documentVisible = true
            //获取当事人签名二维码
            clerkConfirmQrCode({
                docId: this.documentId
            }).then(res => {
                if(res.data.code == ERR_OK){
                    this.wxSignCode = res.data.data.launchSign+'/gzzc'
                    this.fileSignList = [{name:"笔录签名",url:this.wxSignCode}]
                }
            },erro =>{

            })
        },
        clickAllDownLoad() {
            filedownload('/gzzc/meeting/clickDownLoad',{
                meetingId: this.$route.query.meetingId,
            },'相关材料.zip')
        },
        downSingleFile(item){
            filedownload('/gzzc/envCaseMaterial/getEnvCaseMaterial',{
                fileId: item.fileId,
                id: item.id,
                meetingId:this.$route.query.meetingId,
                caseId: this.$route.query.caseId ? this.$route.query.caseId :""
            },item.fileName)
        },
        downRecordFile(item){
            filedownload('/gzzc/clerkRecord/getClerkRecordMaterial',{
                id: item.id,
            },item.fileName)
        },

        formatName (row) {
            return row.fileName + this.getType(row.fileId)
        },
        getType(file){
            var filename=file;
            var index1=filename.lastIndexOf(".");
            var index2=filename.length;
            var type=filename.substring(index1,index2);
            return type;
        },
        //返回会议列表
        goMeetingList(){
            this.$router.go(-1)
        },
        open(value){
            console.log(value)
        },
        rowClass({row, column, rowIndex, columnIndex}) {
            if (columnIndex === 2 || columnIndex === 3 || columnIndex === 4) {
                return 'color: #fff'
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        getCaseDetail() {

        },
        getMeetingDetail() {
            let params = {
                caseId: this.$route.query.caseId,
                meetingId: this.$route.query.meetingId,
            }
            getMeetingDetail(params).then(res => {
                if(res.data.code == ERR_OK){
                    let dataList = res.data.data , tempMember = []
                    let bookDate =  new Date(dataList.meetingDetailResDTO.orderTime)
                    this.typeform.type = dataList.meetingDetailResDTO.meetingType
                    this.meetinTittle = dataList.meetingDetailResDTO.name
                    this.causeName = dataList.meetingDetailResDTO.causeName
                    this.meetingDate = dateformat(bookDate, 'yyyy-MM-dd hh:mm')
                    this.memberList = dataList.meetingDetailResDTO.mediationRoomUserList
                    this.caseNum = dataList.mediationCaseBaseDTO ? (dataList.mediationCaseBaseDTO.caseNo ? dataList.mediationCaseBaseDTO.caseNo :'无') : ''
                    this.caseDescribe = dataList.mediationCaseBaseDTO ? (dataList.mediationCaseBaseDTO.disputeContent ? dataList.mediationCaseBaseDTO.disputeContent :'无') : ''
                    this.memberList = dataList.meetingDetailResDTO.mediationRoomUserList
                    if(dataList.mediationCaseBaseDTO) {
                        if(this.loginUserId == dataList.mediationCaseBaseDTO.creatorId || this.loginUserId == dataList.meetingDetailResDTO.creatorId){
                            this.createdFlag = true
                            this.dialogTittle = '制作笔录'
                        }
                        dataList.meetingDetailResDTO.mediationRoomUserList.forEach(element => {
                            if(element.userId == this.loginUserId && this.loginUserId != dataList.mediationCaseBaseDTO.creatorId && this.loginUserId != dataList.meetingDetailResDTO.creatorId && (this.recordAttaList&&this.recordAttaList.length>0)){
                                this.attendFlag = true
                                this.dialogTittle = '笔录签署'
                            }
                        })
                    }
                     //this.allFile.fileform = dataList.lawAttachList
                    if(dataList.lawAttachList && dataList.lawAttachList.length >0){
                            if( dataList.lawAttachList[0].categoryMiddle ||  dataList.lawAttachList[0].fileName ||  dataList.lawAttachList[0].remark){
                                this.allFile.fileform = dataList.lawAttachList.map(item => {
                                    if (!item.remark) {
                                        item.remark = item.fileName
                                    }
                                    return item
                                })
                            } else {
                                this.allFile.fileform  = []
                                this.downFlag = false
                            }
                    } else {
                        this.allFile.fileform  = []
                        this.downFlag = false
                    }

                }
            },erro =>{

            })
        },
        goBack () {
            this.$router.go(-1)
        },
        saveInviteVisitors() {
            inviteVisitorsnopic({
                meetingId: this.$route.query.meetingId,
                meetingUserType: 'INVITATION_WATCHER_NO_PICTURE',
                name: this.invitenopic.userName,
                phone: this.invitenopic.mobilePhone
            }).then(res => {
                if(res.data.code == ERR_OK){
                    this.$message({
                        message: '邀请成功',
                        type: 'success'
                    });
                }
            },erro =>{

            })
        }
    },
    components:{

    }
}
</script>
<style lang="scss">
.single-detail{
    .book-meeting{
        height: 60px;
        background: #fff;
        position: relative;
        color: #333333;
        padding-left: 40px;
        line-height: 60px;
        font-size: 16px;
        .meeting-arrow {
            cursor: pointer;
            left: 24px ;
            top:25px;
            position: absolute;
            display: inline-block;
            width: 10px;
            height: 10px;
            border-top: 2px solid #867f7a;
            border-right: 2px solid #867f7a;
            transform: rotate(-135deg);
            margin-right: -50px;
        }
    }
    .meeting-type {
        margin-top: 10px;
        background-color: #ffffff;
        .type-tittle{
            padding-left: 24px;
            &:before{
                display: inline-block;
                position: relative;
                left:0;
                top:3px;
                content: '';
                width: 4px;
                height: 16px;
                background-image: linear-gradient(110deg,
                    #0083c8 0%,
                    #05c886 100%),
                linear-gradient(
                    #15c086,
                    #15c086);
                background-blend-mode: normal,
                    normal;
            }
            line-height: 50px;
            height: 50px;
            border-bottom: 1px solid #e7e7e7;
            span {
                display: inline-block;
                margin-left: 10px;
                font-size: 16px;
                color: #333;

            }
        }
        .first-form {
            padding: 10px 0;
            .book-time-date {
                .el-form-item {
                    .el-form-item__label {
                        margin-right: 50px;
                    }
                }
            }
            .el-form-item {
                margin: 0;
            }
        }
    }
    .meeting-time {
        .content{
            padding: 20px;
            overflow: hidden;
            .theme{
                width: 50%;
                float: left;
                .theme-tittle {
                    font-size: 14px;
                    color: #999999;
                }
                .theme-cont{
                    color: #333333;
                    font-size: 14px;
                }
            }
            .case-number{
                width: 50%;
                float: left;
                .theme-tittle {
                    font-size: 14px;
                    color: #999999;
                }
                .theme-cont{
                    color: #333333;
                    font-size: 14px;
                }
            }
        }
        .case-describle {
            padding: 0 0 20px 20px;
            .theme-tittle {
                font-size: 14px;
                color: #999999;
            }
            .theme-cont{
                color: #333333;
                font-size: 14px;
            }
        }
    }
    .single-time {
        .time {
            padding: 20px 0 20px 20px;
            .date {
                font-size: 14px;
                color: #999999;
            }
            .date-detail {
                color: #333333;
                font-size: 14px;
            }
        }
    }
    .relation-meterail {
        margin-top: 10px;
        background-color: #ffffff;
        .no-data{
            padding: 80px 0;
            margin: 0 auto;
            font-size: 16px;
            color: #999;
            width: 100px;
        }
        .file-form {
            padding: 20px 20px 0;
            .el-row{
                .el-col-1 {
                    cursor: pointer;
                    line-height: 30px;
                     color:#0083c8;
                     font-size: 14px;
                     width: 60px;
                }
            }
            .el-select{
                width: 100%;
            }
        }

        .type-tittle{
            padding-left: 24px;
            overflow: hidden;
            &:before{
                display: inline-block;
                position: relative;
                left:0;
                top:3px;
                content: '';
                width: 4px;
                height: 16px;
                background-image: linear-gradient(110deg,
                    #0083c8 0%,
                    #05c886 100%),
                linear-gradient(
                    #15c086,
                    #15c086);
                background-blend-mode: normal,
                    normal;
            }
            line-height: 50px;
            height: 50px;
            border-bottom: 1px solid #e7e7e7;
            .meterail {
                //float: left;
                display: inline-block;
                margin-left: 10px;
                font-size: 16px;
                color: #333;

            }
            .all-load {
                width: 80px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                float: right;
                border-radius: 4px;
                border: solid 1px #0083c8;
                color:  #0083c8;
                margin:10px 20px 0 0;
                cursor: pointer;
                &:hover{
                    color: #fff;
                    background: #0083c8;
                }
            }

        }
        .tab-name {
            display: inline-block;
        }
        .tab-select{
            display: inline-block;
            margin-left: 15px;
        }
        .table_4_column_2{
            display: none;
        }
        .dowm-load {
            color:#0083c8;

        }

    }

    .attendant-number {
        margin-top: 10px;
        min-height: 200px;
        padding-bottom: 20px;
        background-color: #ffffff;
        .type-tittle{
            padding-left: 24px;
            &:before{
                display: inline-block;
                position: relative;
                left:0;
                top:3px;
                content: '';
                width: 4px;
                height: 16px;
                background-image: linear-gradient(110deg,
                    #0083c8 0%,
                    #05c886 100%),
                linear-gradient(
                    #15c086,
                    #15c086);
                background-blend-mode: normal,
                    normal;
            }
            line-height: 50px;
            height: 50px;
            border-bottom: 1px solid #e7e7e7;
            span {
                display: inline-block;
                margin-left: 10px;
                font-size: 16px;
                color: #333;
                span {
                    color: #cccccc;
                    font-size: 12px;
                }
            }
        }
        .number {
            margin: 30px;
            overflow: hidden;
            p{
                margin-top: 15px;
                float: left;
                width: 50%;
                .member-name {
                    font-size: 14px;
                    color: #999999;
                }
                .member-single{
                    color: #333333;
                    font-size: 14px;
                }
            }
        }
        .attendant-form-detail {
            .el-row {
                width: 100%;
                display: flex;
                padding: 20px;
            }
        }
        .addpeo-button {
            float: right;
            margin: 11px 20px;
            font-size: 14px;
            display: inline-block;
            border-radius: 4px;
            margin-left: 20px;
            width: 80px;
            height: 30px;
            line-height: 30px;
            border: 1px solid #0083c8;
            color:#0083c8;
            text-align: center;
            cursor: pointer;
            &:hover{
                color: #fff;
                background: #0083c8;
            }
        }
    }
    .footer {
        margin-top: 20px;
        width: 100%;
        height: 110px;
        background: #fff;
        text-align: center;
        line-height: 110px;
        display: flex;
        align-items: center;
        justify-content: center;
        .sumbmit-form{
            overflow: hidden;
            width: 300px;

            margin: 0 auto;
            .sumbit{
                width: 120px;
                height: 40px;
                float: left;
                line-height: 40px;
                font-size: 16px;
                color: #fff;
                margin-right: 15px;
                background-image: linear-gradient(110deg,
                    #0083c8 0%,
                    #05c886 100%),
                linear-gradient(
                    #0083c8,
                    #0083c8);
                background-blend-mode: normal,
                    normal;
                box-shadow: 0px 3px 7px 0px
                    rgba(76, 197, 156, 0.3);
                border-radius: 4px;
                cursor: pointer;
            }
            .concel{
                margin-left: 15px;
                width: 120px;
                height: 40px;
                color:  #0083c8;
                font-size: 16px;
                float: left;
                border-radius: 4px;
                border: solid 1px #0083c8;
                line-height: 40px;
                cursor: pointer;
                &:hover{
                    color:#fff;
                    background:  #0083c8;
                }
            }
        }
    }
}
.el-dialog__wrapper{
    .el-dialog {
        .el-dialog__body {
            .dialog-footer {
                text-align: center;
                margin-top: 10px;
            }
        }
    }

}
.detail-record {
    .btnlr-gradient {
        //color: #fff;
    }
    .el-button+.el-button {
        margin-left: 30px;
    }
    .md-head {
        height: 30px;
        margin: 26px 0 22px;
        line-height: 30px;
        text-align: right;
        > span {
            float: left;
            font-size: 14px;
            font-weight: bold;
        }
        .el-input {
            width: 150px;
        }
        .el-input--small .el-input__inner {
            height: 26px;
            line-height: 26px;
            width: 121px;
        }
    }
    .md-wrap {
        padding-bottom: 10px;
        .signstatus {
            padding: 10px 0;
            text-align: center;
            border-bottom: 1px solid #ddd;
        }
    }
    .vc {
        padding-top: 20px;
        padding-right: 20px;
    }
    i.dialog_edit_icon {
        position:absolute;
        display: inline-block;
        top: 16px;
        right: 60px;
        width: 20px;
        height: 20px;
        background: url("../meeting/assets/img/dialog_edit.png") no-repeat center;
        cursor: pointer;
    }
}
.document-sign {
    .el-dialog__body{
        height: 440px;
        padding: 30px 40px;
        .dialog-footer {
            text-align: center;
            margin-top: 10px;
        }
        .line {
            border-bottom: dashed 1px #666666;
        }
        .sign-line {
            margin-top: 26px;
        }
        .sign-top {
            display: flex;
            margin-bottom: 26px;
            img {
                width: 140px;
                height: 140px;

            }
            .hold-sign {
                width: 140px;
                height: 140px;
                display: inline-block;
                text-align: center;
                line-height: 140px;
                color: #999;
                font-size: 18px;
                background-color: #fafafa;
	            box-shadow: 0px 3px 6px 0px
	        	rgba(186, 186, 186, 0.2);
            }
            .sign-discrible {
                display: inline-block;
                margin-left: 45px;
                .explain  {
                    margin: 25px 25px 15px 25px;
                }
                .no-set {
                    color:#e8151f;
                    cursor: pointer;
                }
                .sort {
                    margin-top: 20px;
                    .num {
                        width: 16px;
                        height: 16px;
                        display: inline-block;
                        background-color: #15c086;
                        border-radius: 50%;
                        text-align: center;
                        color: #fff;
                        margin-right: 11px
                    }
                    .scan {
                        color: #15c086;
                    }
                }
                .reset {
                    margin-left: 26px;
                }
            }
        }
        .end {
            width: 210px;
            height: 40px;
            float: left;
            line-height: 40px;
            font-size: 16px;
            color: #fff;
            margin: 30px 0  0 80px;
            background-image: linear-gradient(110deg, #0083c8 0%, #05c886 100%), linear-gradient(#0083c8, #0083c8);
            background-blend-mode: normal, normal;
            -webkit-box-shadow: 0px 3px 7px 0px rgba(76, 197, 156, 0.3);
            box-shadow: 0px 3px 7px 0px rgba(76, 197, 156, 0.3);
            border-radius: 4px;
            cursor: pointer;
            text-align: center;
        }
    }
}


</style>

